import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

export interface FeatureFlagsUpdate {
  id: number;
  featureName: string;
  isEnabled: boolean;
}

export interface UpdateFeatureFlagsDto {
  token: string;
  featureFlag: FeatureFlagsUpdate[];
}

export const updateFeatureFlags = async ({
  token,
  featureFlag,
}: UpdateFeatureFlagsDto) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/feature/update-feature-flag`,
      {
        featureFlag: featureFlag,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);
    (error as Error).message = message;
    throw error;
  }
};
